import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';

import { TProviderUser, TProviderUserPayloadUpdate, TProviderUserResponse, adaptProviderUserFromResponse, adaptProviderUserToRequest } from '../../types';
import { TSliceInitialState, useAppSelector } from '../../hooks';
import { BACKEND_ADMIN_PROVIDER_USER } from '../../backend-paths';


export const providerUserUpdateApi = createAsyncThunk(
	`PUT/${BACKEND_ADMIN_PROVIDER_USER}/:id`,
	(payload: TProviderUserPayloadUpdate, thunkApi) => {
		const { data, id } = payload;
		const path = `${BACKEND_ADMIN_PROVIDER_USER}/${id}`;
		const dataRequest = adaptProviderUserToRequest(data);

		return HttpService.put<TProviderUserResponse>(path, dataRequest).then(result => {
			return adaptProviderUserFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

const initialState: TSliceInitialState<TProviderUser> = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const providerUserUpdateSlice = createSlice({
	name: 'providerUserUpdateSlice',
	initialState,
	reducers: {
		clearProviderUserUpdate(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[providerUserUpdateApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[providerUserUpdateApi.fulfilled.type]: (state, action: PayloadAction<TProviderUser>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[providerUserUpdateApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useProviderUserUpdateSelector = () => useAppSelector(state => state[providerUserUpdateSlice.name]);

export const { clearProviderUserUpdate } = providerUserUpdateSlice.actions;
